var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaypal = function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paypal_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#179BD7",
    d: "M35.656 11.528c-.48-.545-1.074-.997-1.77-1.365q-.056.356-.128.729-.068.348-.145.683c-1.585 6.922-6.008 9.89-11.773 10.515q-.576.062-1.17.093-.653.036-1.324.035h-3.648c-.876 0-1.614.636-1.751 1.501l-1.654 10.489-.214 1.355-.528 3.357a.934.934 0 0 0 .92 1.08h6.47c.766 0 1.417-.557 1.538-1.312l.064-.33 1.217-7.73.079-.425a1.555 1.555 0 0 1 1.538-1.314h.967c6.269 0 11.176-2.544 12.61-9.91.598-3.075.288-5.644-1.298-7.451"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253B80",
    d: "m13.948 23.72.06-.384 2.073-13.131a1.55 1.55 0 0 1 1.535-1.314h9.746c1.154 0 2.232.076 3.215.235q.42.068.82.155a14 14 0 0 1 1.055.285l.087.028.049.018q.694.233 1.294.549.003 0 .006.002c.487-3.112-.005-5.23-1.687-7.148C30.347.905 27.001 0 22.717 0H10.285C9.41 0 8.663.636 8.528 1.502L3.35 34.328c-.102.65.4 1.235 1.054 1.235h7.675l.214-1.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#222D65",
    d: "M33.88 10.161a9 9 0 0 0-1.294-.548l-.049-.019-.087-.027q-.138-.044-.28-.087-.377-.108-.774-.198-.4-.088-.821-.155a20 20 0 0 0-3.215-.235h-9.746a1.55 1.55 0 0 0-1.535 1.313l-2.074 13.131-.06.384c.137-.865.876-1.501 1.752-1.501h3.647a24 24 0 0 0 2.495-.13c5.765-.623 10.188-3.592 11.772-10.514a20 20 0 0 0 .273-1.411z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paypal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgPaypal;